// @flow

// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'

// Selectors
import { users$ } from 'fc-users'

// Constants
import {
  PROP_ROLES,
} from 'fc-model-users'

export default createSelector(
  [
    users$,
  ],
  function (users: UsersById): Array<User> {
    return _filter(users, (user: User): Array<User> => user[PROP_ROLES].includes('Hefty'))
  }
)
